// import { create } from 'zustand';

// interface EventModalStore {
//   isOpen: boolean;
//   onClose: () => void;
//   onOpen: () => void;
// }

// export const useEventModalStore = create<EventModalStore>((set) => ({
//   isOpen: false,
//   onClose: () => set({isOpen: false}),
//   onOpen: () => set({isOpen: true}),
// }))


// store.ts
import { create } from "zustand"

interface EventModalStore {
  selectedEventId: string | null
  onOpen: (id: string) => void
  onClose: () => void
}

export const useEventModalStore = create<EventModalStore>((set) => ({
  selectedEventId: null,
  onOpen: (id) => set({ selectedEventId: id }),
  onClose: () => set({ selectedEventId: null }),
}))